/**
 * @jsxRuntime classic
 * @jsx jsx
 */
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { css, keyframes } from '@emotion/react';
import { B75, B300 } from '@atlaskit/theme/colors';
var flashTime = 700;

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var flashAnimation = keyframes({
  '0%': {
    backgroundColor: 'transparent'
  },
  '20%': {
    backgroundColor: "var(--ds-background-selected-pressed, ".concat(B75, ")"),
    borderColor: "var(--ds-border-selected, ".concat(B300, ")")
  },
  '75%': {
    backgroundColor: "var(--ds-background-selected-pressed, ".concat(B75, ")"),
    borderColor: "var(--ds-border-selected, ".concat(B300, ")")
  },
  '100%': {
    backgroundColor: "var(--ds-background-selected-pressed, ".concat(B75, ")"),
    borderColor: "var(--ds-border-selected, ".concat(B300, ")")
  }
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var containerStyle = css({
  width: '100%',
  height: '100%'
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var flashStyle = css({
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
  animation: "".concat(flashAnimation, " ").concat(flashTime, "ms ease-in-out")
});